import { useMemo, useState } from 'react';

function buildThresholdList() {
  const thresholds = [];
  const numSteps = 20;

  for (let i = 1.0; i <= numSteps; i++) {
    const ratio = i / numSteps;

    thresholds.push(ratio);
  }

  thresholds.push(0);

  return thresholds;
}

function createObserver(element: HTMLElement, handleIntersect: IntersectionObserverCallback) {
  const observer = new IntersectionObserver(handleIntersect, {
    root: null,
    rootMargin: '0px',
    threshold: buildThresholdList(),
  });

  observer.observe(element);
}

export default function useIntersectionObserver(element: HTMLElement) {
  const elementHeight = useMemo(() => element?.getBoundingClientRect().height ?? 0, [element]);
  const [elementViewportHeight, setElementViewportHeight] = useState(elementHeight);

  function handleIntersect(entries: IntersectionObserverEntry[]) {
    entries.forEach((entry) => setElementViewportHeight(entry.intersectionRatio * elementHeight));
  }

  element && createObserver(element, handleIntersect);

  return {
    elementViewportHeight,
  };
}
